<template>
  <ul class="list-disc pl-5 space-y-1">
    <li v-for="(item, index) in items" :key="index">
      {{ item }}
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue'
import { defineProps } from 'vue'

const props = defineProps({
  instructions: {
    type: String,
    default: ''
  }
})

const items = computed(() => {
  return props.instructions
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(line => /^-\s*/.test(line))
      .map(line => line.replace(/^-\s*/, '').trim())
})
</script>